import React, { FC } from "react";
import { Button, Typography } from "@mui/material";
import { IconPreview } from "../../../../../../../utils/icons";

interface Props {
  previewLink?: string;
  handleSubmit?: () => void;
}

export const Controls: FC<Props> = ({ previewLink, handleSubmit }) => (
  <div className="flex gap-2 pt-4 px-6 justify-end">
    <Button
      size="large"
      variant="outlined"
      disableElevation
      onClick={() => window.open(previewLink, "_blank")}
      sx={{ textTransform: "inherit" }}
    >
      <div className="flex gap-[6px]">
        <Typography color="var(--text)">
          Open preview link{" "}
        </Typography>
        <IconPreview />
      </div>
    </Button>
    <Button
      size="large"
      type="submit"
      variant="contained"
      disableElevation
      onClick={handleSubmit}
      sx={{ textTransform: "inherit" }}
    >
      Save changes
    </Button>
  </div>
);
